module.exports = __webpack_public_path__ + "img/shiduqiuyou.896eeb62.png";